import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { faTimes, faSave } from '@fortawesome/pro-regular-svg-icons';
import { ItemExtended, Site } from 'src/app/models';

@Component({
  selector: 'app-transfer-cart-items-dialog',
  templateUrl: './transfer-cart-items-dialog.component.html',
  styles: [``],
})
export class TransferCartItemsDialogComponent implements OnInit {
  public form: FormGroup;
  public faTimes = faTimes;
  public faSave = faSave;

  constructor(
    public dialogRef: MatDialogRef<TransferCartItemsDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      items: ItemExtended[];
      sites: Site[];
    },
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      siteId: [null, Validators.required],
    });
  }

  cancel() {
    this.dialogRef.close(null);
  }

  save() {
    if (this.form.valid) {
      this.dialogRef.close(this.form.value.siteId);
    }
  }
} 